module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', [_c('div', {
    staticClass: "home-page justify-content-md-center",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    attrs: {
      "id": "stats-banner"
    }
  }, [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "leftbox-header",
    on: {
      "click": function($event) {
        return _vm.goTo('home')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left"
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('div', {
    staticClass: "middlebox-header"
  }, [_c('h2', [_vm._v("\n              Min\n              "), _c('b', {
    staticClass: "takt-success"
  }, [_vm._v("\n                " + _vm._s(_vm.minLeadtime) + " J\n              ")]), _vm._v(" -\n              Moyenne\n              "), _c('b', {
    staticClass: "takt-mean"
  }, [_vm._v("\n                " + _vm._s(_vm.avgLeadtime) + " J\n              ")]), _vm._v(" -\n              Max\n              "), _c('b', {
    staticClass: "takt-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.maxLeadtime) + " J\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "stats-more"
  }, [_c('p', [_vm._v("Voir toutes les cartes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showAllCards),
      expression: "showAllCards"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showAllCards) ? _vm._i(_vm.showAllCards, null) > -1 : (_vm.showAllCards)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showAllCards,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showAllCards = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showAllCards = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showAllCards = $$c
        }
      }, _vm.filterCheckBoxStateChanged]
    }
  })])])]), _vm._v(" "), _c('b-col', [_c('div', {
    staticClass: "rightbox-header",
    on: {
      "click": _vm.changeVue
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto",
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../assets/bouton-changer-de-vue.png")
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "andon-list"
    }
  }, [(this.actualVue == 'classic') ? _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('br'), _vm._v(" "), _c('b-row', _vm._l((_vm.internalSupplierList), function(supplier, name, index) {
    return _c('b-col', {
      key: index,
      staticClass: "andon-col",
      attrs: {
        "lg": ""
      }
    }, [_c('div', {
      staticClass: "header-list-kb"
    }, [_c('h3', {
      staticClass: "name-title"
    }, [_vm._v(" " + _vm._s(name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "number-kb-info"
    }, [_vm._v(_vm._s(supplier.length))])]), _vm._v(" "), _vm._l((supplier), function(element) {
      return _c('div', {
        key: element.cardId,
        staticClass: "andon-card",
        on: {
          "contextmenu": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.handleClick($event, element)
          },
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.handleClick($event, element)
          }
        }
      }, [_c('BoardCard', {
        attrs: {
          "cardId": element.cardId,
          "computedLeadTime": _vm.computeLeadTime(element),
          "cardContact": _vm.contactDefinition(element),
          "askingDate": _vm.cellDelayAsk(element),
          "cardDescription": element.descriptif,
          "andon": _vm.cellClass(element)
        }
      })], 1)
    })], 2)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.actualVue == 'andonList') ? _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "header-list-kb"
  }, [_c('div', {
    staticClass: "number-kb-info"
  }, [_vm._v(_vm._s(_vm.andonKardcounter))])]), _vm._v(" "), _vm._l((_vm.kanbanAndonList), function(element, index) {
    return _c('div', {
      key: index,
      staticClass: "andon-card",
      on: {
        "contextmenu": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.handleClick($event, element)
        },
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.handleClick($event, element)
        }
      }
    }, [_c('BoardCard', {
      attrs: {
        "cardId": element.cardId,
        "computedLeadTime": _vm.computeLeadTime(element),
        "cardContact": _vm.contactDefinition(element),
        "askingDate": _vm.cellDelayAsk(element),
        "cardDescription": element.descriptif,
        "andon": _vm.cellClass(element),
        "internalSupplier": element.internal_supplier
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (this.actualVue == 'statistique') ? _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-button', {
    staticClass: "btn-csv",
    attrs: {
      "variant": "dark"
    },
    on: {
      "click": _vm.exportCSV
    }
  }, [_vm._v("export csv")]), _vm._v(" "), (_vm.finishLoop == true) ? _c('DocumentStatGraph', {
    attrs: {
      "series": this.dataScatterGraph.series,
      "categories": this.dataScatterGraph.categories,
      "colors": ['#3d71bf', '#4bc9b9', '#a04bd1']
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('reatribution-kanban-modal', {
    ref: "reatribute-kanban",
    attrs: {
      "customer": _vm.internalCustomer,
      "supplier": _vm.internalSupplier,
      "card": _vm.cardNumber,
      "office": _vm.office
    }
  }), _vm._v(" "), _c('EndKanbanBeModal', {
    ref: "end-kanban-be-modal",
    on: {
      "saved": _vm.getKanbanCard
    }
  }), _vm._v(" "), _c('CancelKanbanBeModal', {
    ref: "cancel-kanban-be-modal",
    on: {
      "saved": _vm.getKanbanCard
    }
  })], 1)]), _vm._v(" "), _c('VueSimpleContextMenu', {
    ref: 'vueSimpleContextMenu',
    attrs: {
      "elementId": 'context-menu-andon',
      "options": _vm.contextMenuList
    },
    on: {
      "option-clicked": _vm.optionClicked
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ae1e421","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/KanbanBoard.vue
// module id = 714
// module chunks = 1